import ImageCTA from "@components/Image/ImageCTA";
import { Link } from "@components/Link/Link";
import React from "react";
import tw, { styled } from "twin.macro";
import { withFeaturedArticleCard } from "./withFeaturedArticleCard";

const Wrapper = tw.div`
  flex flex-col w-1/2 p-micro sm:p-mini lg:w-1/4
`;

const ImageWrapper = tw.div`w-full`;

const ContentWrapper = tw.div`flex-1 flex flex-col`;

const Content = tw.div`flex-1 focus-visible:!outline-offset-[-1px]`;

const Title = styled.p`
  ${tw`text-body leading-h4 block font-display my-micro sm:text-h3 md:text-[32px] md:font-medium md:my-mini`}
  hyphens: none;
  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
`;

const Summary = tw.p`
  hidden text-body leading-body opacity-70 md:block
`;

const StyledLink = styled(Link)`
  ${tw`flex-none text-caption leading-caption sm:text-body md:hidden hover:text-warning`}
`;

const FeaturedArticleCard = withFeaturedArticleCard(
  ({ title, image, summary, link }) => {
    return (
      <Wrapper>
        <ImageWrapper>
          <ImageCTA
            sanityImage={image}
            buttonText="Read more"
            buttonLink={link}
            alt={image?.alt || ""}
            blog={true}
          />
        </ImageWrapper>
        <ContentWrapper>
          <Content>
            {title && (
              <Link to={link}>
                <Title>{title}</Title>
              </Link>
            )}
            {summary && <Summary>{summary}</Summary>}
          </Content>
          {title && (
            <StyledLink className="underlined-black" to={link}>
              <span>Read more</span>
            </StyledLink>
          )}
        </ContentWrapper>
      </Wrapper>
    );
  },
);

export default FeaturedArticleCard;
